module.exports = __webpack_public_path__ + "static/media/profilePlaceholder-4.33926495.png";